import styled from 'styled-components';

export const Card = styled.div`
  width: 100%;
  height: 38px;
  background-color: ${({ theme }) => theme.palette.NL20};
  border-radius: 8px;
  padding: 4px 8px;
  display: flex;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    height: 92px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  object-fit: contain;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 5px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.DESKTOP})`} {
    flex-direction: row;
    gap: 10px;
    padding: 0;
  }
`;

export const Title = styled.div`
  padding-bottom: 10px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    text-align: center;
  }
`;
